import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {VisitScheduleModel} from "../../../models/visit-schedule.model";
import {VisitScheduleOptimizationSettings} from "../../../models/visit-schedule-optimization-config.model";
import {VisitPlanModel} from "../../../models/visit-plan.model";

export const VisitScheduleChannelActions = createActionGroup({
  source: '[VisitSchedule/Channel]',
  events: {
    subscribe: emptyProps(),
    subscribePartial: emptyProps(),
    unsubscribe: emptyProps(),
    unsubscribeSuccess: emptyProps(),
    notificationReceived: props<{ notification: VisitScheduleModel }>(),
    partialNotificationReceived: props<{ notification: VisitScheduleModel }>(),
  }
});

export const VisitScheduleAPiActions = createActionGroup({
  source: '[VisitSchedule/API]',
  events: {
    //Init Visit Schedule
    initVisitSchedule: props<{ visitPlanId: string, visitScheduleConfig: VisitScheduleOptimizationSettings }>(),
    initVisitScheduleSuccess: props<{ visitPlan: VisitPlanModel, visitScheduleConfig: VisitScheduleOptimizationSettings}>(),
    initVisitScheduleFailure: props<{ error: any }>(),

    //Get Visit Schedule
    getVisitSchedule: props<{ visitPlanId: string, visitScheduleId: string, isSubscribeToChannel?: boolean }>(),
    getVisitScheduleSuccess: props<{ visitSchedule: VisitScheduleModel, isSubscribeToChannel?: boolean }>(),
    getVisitScheduleFailure: props<{ error: any }>(),

  }
});

export const VisitScheduleActions = createActionGroup({
  source: '[VisitSchedule]',
  events: {
    setOne: props<{ visitSchedule: VisitScheduleModel, isSubscribeToChannel?: boolean }>(),
    removeAll: emptyProps(),
    clearStore: emptyProps()
  }
});

